import {CustomerModel, DtoCustomerOrgInterface} from "../interfaces";

export const mapCustomerFromDto = (dto: DtoCustomerOrgInterface): CustomerModel => {
  return {
    customerOrgId: dto.customerOrgId ?? "",
    name: dto.name,
    name2: dto.name2,
    street: dto.street,
    houseNumber: dto.houseNumber,
    postalCode: dto.postalCode,
    city: dto.city,
    country: dto.country,
    assetCount: dto.assetCount,
    trumpfCompanies: dto.trumpfCompanies ?? []
  };
};

export const mapCustomerFromDtoArray = (array: Array<DtoCustomerOrgInterface>): Array<CustomerModel> => {
  const result: Array<CustomerModel> = [];

  array.forEach(dto => {
    result.push(mapCustomerFromDto(dto));
  });

  return result;
};
